// Hook para manejar los KPIs de errores
// Hook for managing errors KPIs

import { useQuery } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { ErrorsKpisApiAdapter, ErrorsKpisParams } from '../adapters/ErrorsKpisApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';
import { useDashboardFilters } from './useDashboardFilters';

export const useErrorsKpis = (params: ErrorsKpisParams = {}) => {
  const { toast } = useToast();
  const { setRefreshingComplete } = useDashboardFilters();
  const errorsKpisAdapter = new ErrorsKpisApiAdapter(apiClientWH);

  const {
    data: errorsKpisResponse,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['errorsKpis', params],
    queryFn: () => errorsKpisAdapter.getErrorsKpis(params),
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
    onSuccess: () => {
      setRefreshingComplete();
    },
    onError: (error: any) => {
      setRefreshingComplete();
      toast({
        title: 'Error al cargar métricas de errores',
        description: error?.message || 'Error inesperado. Inténtalo de nuevo.',
        variant: 'destructive',
      });
    },
  });

  return {
    errorsKpis: errorsKpisResponse?.data || {
      order_with_incorrect_address: 0,
      order_with_payment_errors: 0,
      order_with_unlinked_product: 0,
      order_with_stock_errors: 0,
      order_with_other_errors: 0,
      total_orders_with_errors: 0,
    },
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};
